import styled from 'styled-components'

export const Container = styled.ol`
  list-style-type: decimal;
  font-weight: 600;
`
